import React from "react";
import "./template-preview.css"

export const HeaderPreview = ({ header }) => {
    const { selectedHeaderType, imageMaxHeight, imageUrl, videoUrl } = header;
    const lowerCaseType = selectedHeaderType;
    const mediaStyle = { maxHeight: imageMaxHeight };

    if (lowerCaseType === "image") {
        const source = imageUrl || "https://storage.gadget.dev/files/22129/42940/media/file/SuDoCyhFJkwqnGPOm30Of/5dd9eda2-817f-40c4-84d2-f5674654ec97";
        return <img className="header-preview" alt="En-tête de la campagne" src={source} style={mediaStyle} />;
    }

    if (lowerCaseType === "video") {
        const source = videoUrl || "https://storage.gadget.dev/files/22129/42940/media/file/xDycluQ_j76bA150Asp7G/2bc118d2-9e93-405c-9b5e-dced1b1051c0";
        if (videoUrl) {
            return <video className="header-preview" src={source} style={mediaStyle} />;
        }
        return <img className="header-preview" alt="En-tête de la campagne" src={source} style={mediaStyle} />;
    }

    return null;
};
